import React, { useEffect, useState } from 'react'
import { getURL, postAPI } from '../../app/api';
import { store, setStore } from '../../app/store';

export default function ForgetPassword() {
  const store_data = JSON.parse(store());
  const [IsBTNClicked, setIsBTNClicked] = useState(false);
  const [FormData, setFormData] = useState({})
  const [OrganizationData, setOrganizationData] = useState({});
  const [API_URL, setAPIURL] = useState("");


  const fetchURL = async () => {
    const URL = await getURL();
    setAPIURL(URL);
  };

  const handleChange = e => {
    const { name, value } = e?.target;
    setFormData({ ...FormData, [name]: value })
  }

  const sendOTP = async () => {
    try {
      const response = await postAPI("/users/sendOTP", {...FormData, user: store_data});
      console.log(response);
      if (response?.status == 1) {
        setIsBTNClicked(false);
        setStore({ ...response?.data, username: FormData?.username, is_login: 1, submit: {...FormData, action: 'ResetPassword'} })
        window.location.href = '/Admin/Verification'
      } else {
        setIsBTNClicked(false);
        alert(response?.error)
      }
    } catch (e) {
      setIsBTNClicked(false);
      alert(e?.response?.data?.error)
      console.log("Exception Error: ", e?.response?.data?.error)
    }
  }

  const handleSubmitForgetPassword = async () => {
    setIsBTNClicked(true);
    if (IsBTNClicked) {
    } else {
      const store_data = JSON.parse(store());
      if(store_data?.org_id && store_data?.username && !store_data?.role && store_data?.is_login == 1) {
        window.location.href = '/Admin/Verification'
      } else {
        sendOTP();
      }
    }
  }

  const fetchOrganizationData = async () => {
    try {
      const filter = { reg_domain: window?.location?.host }
      const response = await postAPI("/organization/fetchSingle", {...filter, user: store_data});
      setOrganizationData({
        ...OrganizationData,
        ...response?.data[0]
      })
    } catch (e) {
      console.log("Exception Error: ", e?.response?.data?.error)
    }
  }

  useEffect(() => {
    fetchOrganizationData();
    fetchURL();
  }, [])
  return (
    <>
    <div class="authentication-wrapper authentication-cover authentication-bg">
      <div class="authentication-inner row">
        <div class="d-none d-lg-flex col-lg-7 p-0">
          <div class="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center">
            <img src="../../theme/assets/img/illustrations/auth-forgot-password-illustration-light.png" alt="auth-forgot-password-cover" class="img-fluid my-5 auth-illustration" data-app-light-img="illustrations/auth-forgot-password-illustration-light.png" data-app-dark-img="illustrations/auth-forgot-password-illustration-dark.png" />

            <img src="../../theme/assets/img/illustrations/bg-shape-image-light.png" alt="auth-forgot-password-cover" class="platform-bg" data-app-light-img="illustrations/bg-shape-image-light.png" data-app-dark-img="illustrations/bg-shape-image-dark.png" />
          </div>
        </div>
        <div class="d-flex col-12 col-lg-5 align-items-center p-sm-5 p-4">
          <div class="w-px-400 mx-auto">
            <div class="app-brand mb-4">
              <a href="/Admin" class="app-brand-link gap-2">
                <span class="app-brand-logo demo">
                  {/* <svg width="32" height="22" viewBox="0 0 32 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.00172773 0V6.85398C0.00172773 6.85398 -0.133178 9.01207 1.98092 10.8388L13.6912 21.9964L19.7809 21.9181L18.8042 9.88248L16.4951 7.17289L9.23799 0H0.00172773Z" fill="#7367F0"></path>
                    <path opacity="0.06" fill-rule="evenodd" clip-rule="evenodd" d="M7.69824 16.4364L12.5199 3.23696L16.5541 7.25596L7.69824 16.4364Z" fill="#161616"></path>
                    <path opacity="0.06" fill-rule="evenodd" clip-rule="evenodd" d="M8.07751 15.9175L13.9419 4.63989L16.5849 7.28475L8.07751 15.9175Z" fill="#161616"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.77295 16.3566L23.6563 0H32V6.88383C32 6.88383 31.8262 9.17836 30.6591 10.4057L19.7824 22H13.6938L7.77295 16.3566Z" fill="#7367F0"></path>
                  </svg> */}
                  <img src={`${API_URL}/${OrganizationData?.organization_logo}`} style={{width: '100%'}}  />
                </span>
              </a>
            </div>
            <h3 class="mb-1 fw-bold">Forgot Password? 🔒</h3>
            <p class="mb-4">Enter your email and we'll send you One-Time Password (OTP) to reset your password</p>
            <form id="formAuthentication" class="mb-3 fv-plugins-bootstrap5 fv-plugins-framework" method="POST" novalidate="novalidate">
              <div class="mb-3 fv-plugins-icon-container">
                <label for="email" class="form-label">Email</label>
                <input type="text" class="form-control" id="email" name='username' onChange={handleChange} placeholder="Enter your email" autofocus="" />
              <div class="fv-plugins-message-container invalid-feedback"></div></div>
              <button type='button' class="btn btn-primary d-grid w-100 waves-effect waves-light" onClick={handleSubmitForgetPassword}>{IsBTNClicked ? <> <i class="fas fa-circle-notch fa-spin"></i> &nbsp; &nbsp; </> : <></>} Send One-Time Password (OTP)</button>
            <input type="hidden" /></form>
            <div class="text-center">
              <a href="/Admin/Login" class="d-flex align-items-center justify-content-center">
                <i class="ti ti-chevron-left scaleX-n1-rtl"></i>
                Back to login
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}
